import { render, staticRenderFns } from "./CoPicture.vue?vue&type=template&id=ffdfbfd0&scoped=true&"
import script from "./CoPicture.vue?vue&type=script&lang=js&"
export * from "./CoPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdfbfd0",
  null
  
)

export default component.exports